import { useTranslation } from 'react-i18next';
import { useAuthState } from 'state/useAuthState';
import { useReporterCoverageDebugState } from 'state/useReporterCoverageDebugState';
import { useKeyboardShortcuts } from 'hooks/useKeyboardShortcuts/useKeyboardShortcuts';

/** Registers an internal-only command palette entry (no key binding) to hide the reporter no-coverage overlay. */
export const useReporterCoverageCommandPaletteAction = (): void => {
  const {
    permissions: { isInternalUser },
  } = useAuthState();
  const { isHidden, toggle } = useReporterCoverageDebugState();
  const { t } = useTranslation();

  useKeyboardShortcuts(
    isInternalUser
      ? [
          {
            category: 'mapTools',
            description: t('keyboardShortcuts.mapTools.toggleReporterCoverage'),
            isActive: !isHidden,
            handler: toggle,
          },
        ]
      : [],
    [isInternalUser, isHidden, toggle],
  );
};
